import {CompanyScoreType} from "@SearchResults/features/sidebar/features/companyFilters/types/CompanyScore.type";
import addOrRemoveObjectToArray from "@Array/addOrRemoveObjectToArray";

export default function addOrRemoveCompanyScoreFromFilteredList(companyScores: CompanyScoreType[], companyScore: CompanyScoreType) {
    return addOrRemoveObjectToArray(companyScores, companyScore, 'label');
}